export default "__VITE_ASSET__BSY211bk__"